"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allPages = exports.addPaginationToQueryParameters = exports.serializePagination = exports.defaultPaginationRequest = void 0;
var range_1 = __importDefault(require("lodash/range"));
exports.defaultPaginationRequest = {
    offset: 0,
    limit: 50
};
function serializePagination(pagination) {
    return "offset=" + pagination.offset + "&limit=" + pagination.limit;
}
exports.serializePagination = serializePagination;
function addPaginationToQueryParameters(queryParameters, pagination) {
    return __assign(__assign({}, queryParameters), { offset: pagination.offset, limit: pagination.limit });
}
exports.addPaginationToQueryParameters = addPaginationToQueryParameters;
/**
 * Pagination decorator for pagination aware API connectors, eg. Foundry getUsers
 */
var allPages = function (fn, pageSize, limit) {
    if (pageSize === void 0) { pageSize = 1000; }
    if (limit === void 0) { limit = Number.MAX_SAFE_INTEGER; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var pagination;
            return __generator(this, function (_a) {
                pagination = { offset: 0, limit: pageSize };
                return [2 /*return*/, fn.apply(void 0, __spreadArray(__spreadArray([], args, false), [pagination], false)).then(function (firstResponse) {
                        //  once we've made a request for the first page, we can determine if we need to do additional work
                        if (!firstResponse.pagination ||
                            (firstResponse.pagination.total <= pageSize && firstResponse.pagination.total > limit)) {
                            return firstResponse;
                        }
                        // create promises for pages 2 ... n
                        var otherRequests = (0, range_1.default)(pageSize, Math.min(firstResponse.pagination.total, limit), pageSize).map(function (offset) {
                            pagination = { offset: offset, limit: pageSize };
                            return fn.apply(void 0, __spreadArray(__spreadArray([], args, false), [pagination], false));
                        });
                        // resolve promises for pages 2 ... n and concat on the first response
                        return Promise.all(otherRequests).then(function (otherResponses) {
                            var allResponsesData = otherResponses
                                .map(function (response) { return response.data; })
                                .reduce(function (acc, curr) { return acc.concat(curr); }, firstResponse.data);
                            return { data: allResponsesData };
                        });
                    })];
            });
        });
    };
};
exports.allPages = allPages;
